import { ref } from 'vue'


export default {
  __name: 'AppSidebarCreditInfo',
  setup(__props) {

const isOpen = ref(false)


return { __sfc: true,isOpen, ref }
}

}